import React from 'react'

import { ChildBooking } from 'services/booking/childBooking/constants'
import { Child } from 'services/child/constants'
import { Nursery } from 'services/nurseries/models'

import { ModalBox, Spinner } from 'components'

import i18n from 'translations'

import SendRegistrationFormModalForm, {
  SendRegistrationFormModalFormValues,
} from './components/SendRegistrationFormModalForm'

interface SendRegistrationFormModalViewProps {
  child: Child
  childBookings: ChildBooking[]
  childSessions?: {
    current: any[]
    future: any[]
    past: any[]
  }
  hasAccessToEditRegularBooking: boolean
  isFinanceV3Enabled: boolean
  isLoading: boolean
  isSubmitting: boolean
  nursery?: Nursery
  onCancelClick?: () => void
  onCreateRegularBookingClick: () => void
  onEditChildBookingClick: (childBooking: ChildBooking) => void
  onEnrolmentDetailEditClick: () => void
  onSubmit: (fields: SendRegistrationFormModalFormValues) => void
}

const SendRegistrationFormModalView: React.FC<SendRegistrationFormModalViewProps> = ({
  child,
  childBookings,
  childSessions,
  hasAccessToEditRegularBooking,
  isFinanceV3Enabled,
  isLoading,
  isSubmitting,
  nursery,
  onCancelClick,
  onCreateRegularBookingClick,
  onEditChildBookingClick,
  onEnrolmentDetailEditClick,
  onSubmit,
}) => {
  const renderContent = () => {
    if (isLoading) {
      return <Spinner />
    }

    return (
      <SendRegistrationFormModalForm
        child={child}
        childBookings={childBookings}
        childSessions={childSessions}
        hasAccessToEditRegularBooking={hasAccessToEditRegularBooking}
        isFinanceV3Enabled={isFinanceV3Enabled}
        isSubmitting={isSubmitting}
        nursery={nursery}
        onCancelClick={onCancelClick}
        onCreateRegularBookingClick={onCreateRegularBookingClick}
        onEditChildBookingClick={onEditChildBookingClick}
        onEnrolmentDetailEditClick={onEnrolmentDetailEditClick}
        onSubmit={onSubmit}
      />
    )
  }

  return (
    <ModalBox title={i18n.t('modals:SendRegistrationForm:title')} autoHeight onCloseClick={onCancelClick}>
      {renderContent()}
    </ModalBox>
  )
}
export default SendRegistrationFormModalView
